import Vue from "vue";
import VueRouter from "vue-router";
import {baseRoutes} from './baseRoutes'
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: baseRoutes
});

//路由前置守卫
router.beforeEach((to, from, next) => {
  if (!to.meta.isPublic &&!sessionStorage.token&&!localStorage.token) {
    return next("/Login");
  }
  next();
});

//解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
